import {Injectable} from '@angular/core';
import {
  Router,
  UrlTree,
  RouterStateSnapshot
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "../services/auth.service";


@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  private isUserLoggedIn: boolean = false;

  constructor(private authService: AuthService, private router: Router) {}

  handleAuthGuard(state: RouterStateSnapshot){
    this.isUserLoggedIn = this.authService.isLoggedIn();

    if (!this.isUserLoggedIn) {
      // Capture l'URL actuelle pour la redirection après connexion
      let currentUrl = state.url;
      if(currentUrl.length === 0) {
        let path = window.location.pathname.split('/');
        path = path.filter(x => x !== 'en' && x !== 'fr' && x !== '');
        currentUrl = path.join('/');
      }
      if (currentUrl !== "/") {
        // Rediriger vers la page de connexion avec l'URL de redirection
        return this.router.createUrlTree(['/login'], {
          queryParams: {redirectTo: currentUrl}
        });
      } else {
        // Si l'URL est la racine, rediriger simplement vers la page de connexion
        return this.router.createUrlTree(['/login']);
      }
    }
    return true;
  }

  canActivate(state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   return this.handleAuthGuard(state);
  }

  canActivateChild(state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.handleAuthGuard(state);
  }

}
